import { Button as FloraButton, Text } from '@grupoboticario/flora-react';
import { Container } from 'ui/components/primitives';
import { theme, styled, utils } from 'ui/theme';

export const ShareGuide = {
  PreView: styled(Text)`
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: ${theme.colors.build.darkLight};
  `,

  ShareContent: styled('div')`
    display: flex;
    flex-direction: row;
    margin-top: 20px;
  `,

  DivImg: styled('div')`
    display: grid;
    align-items: center;
  `,

  ShareImg: styled('img')`
    width: 110px;

    ${utils.media.max('s')`
        width: 92px;
    `}
  `,

  ContentLink: styled('div')`
    overflow: hidden;
    overflow-wrap: break-word;
    word-wrap: break-word;
  `,

  TextBox: styled('div')`
    margin-left: 10px;
  `,

  SecondParagh: styled(Text)`
    margin-top: 20px;
  `,

  InfoTexts: styled(Text)`
    font-family: 'Sofia Pro', Helvetica, Arial, sans-serif;
  `,
};
